import React, { FC, ReactElement, useRef } from 'react';
import { IconButton } from 'src/common/icon-button';
import { JourneyMenu } from 'src/common/JourneyMenu';
import { EditStrongIcon, DeleteStrongIcon, DotMenuSmallIcon } from 'src/monet/icons';

import { functionNoop } from 'src/utils/function/noop';
import { Nullable } from 'src/types/nullable.type';

interface BlockSettingsProps {
  editor: any;
  onOpen?: () => void;
  onClose?: () => void;
  onDelete?: () => void;
  settingItems?: Nullable<ReactElement>;
}

export const BlockSettings: FC<BlockSettingsProps> = ({ 
  editor, 
  onOpen = functionNoop, 
  onClose = functionNoop,
  onDelete = functionNoop, 
  settingItems = null 
}) => {
  const openRef = useRef(functionNoop);
  const closeRef = useRef(functionNoop);

  const onSettingsClick = () => {
    openRef.current();
    onOpen();
  };

  const onDeleteClick = () => {
    onDelete();
    onClose();
  };

  const renderOrigin = () => {
    return (
      <IconButton onClick={onSettingsClick}>
        <DotMenuSmallIcon />
      </IconButton>
    );
  };

  return (
    <JourneyMenu
      onClose={onClose}
      openRef={openRef}
      closeRef={closeRef}
      renderOrigin={renderOrigin}
      placement='bottom-end'
    >
      {settingItems}
      <JourneyMenu.Item onClick={onDeleteClick}>
        <div className='flex items-center space-x-2'>
          <DeleteStrongIcon />
          <div>Delete</div>
        </div>
      </JourneyMenu.Item>
    </JourneyMenu>
  );
};
